__turbopack_context__.v({
  "circle": "stepper-module-scss-module__pETKwW__circle",
  "dash": "stepper-module-scss-module__pETKwW__dash",
  "header": "stepper-module-scss-module__pETKwW__header",
  "headerMenu": "stepper-module-scss-module__pETKwW__headerMenu",
  "isActive": "stepper-module-scss-module__pETKwW__isActive",
  "isCompleted": "stepper-module-scss-module__pETKwW__isCompleted",
  "isDisabled": "stepper-module-scss-module__pETKwW__isDisabled",
  "menuWrapper": "stepper-module-scss-module__pETKwW__menuWrapper",
  "step": "stepper-module-scss-module__pETKwW__step",
  "stepTooltip": "stepper-module-scss-module__pETKwW__stepTooltip",
  "title": "stepper-module-scss-module__pETKwW__title",
  "tooltip": "stepper-module-scss-module__pETKwW__tooltip",
  "typeL": "stepper-module-scss-module__pETKwW__typeL",
  "typeM": "stepper-module-scss-module__pETKwW__typeM",
  "typeS": "stepper-module-scss-module__pETKwW__typeS",
});
